const Review = () => {
  return (
    <>
      <div
        id="review"
        className="bg-fixed py-16 bg-gray-100 "
        style={{
          backgroundImage: "url('/assets/review_bg_img.png')",
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl review_heading font-semibold text-gray-800">
              100+ Transport Companies &amp; businesses <br />
              trust
              <a
                href=""
                className="from-[#a200be] to-[#246BFD] bg-gradient-to-tl text-5xl font-bold bg-clip-text text-transparent"
              >
                {" "}
                on TTM4U{" "}
              </a>
              for its reliability and efficiency.
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white review_box p-6 rounded-lg shadow-lg">
              <div className="flex items-center mb-4">
                <div className="mr-4 ">
                  <img
                    src={"/assets/envato.png"}
                    alt="Envato"
                    className="p-3 w-12 h-12 rounded-full bg-green-600"
                  />
                </div>
                <div>
                  <h5 className="font-semibold text-lg text-gray-800">
                    trido23
                  </h5>
                  <span className="text-sm text-gray-500">United States</span>
                </div>
              </div>
              <div className="flex mb-4">
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
              </div>
              <p className="text-gray-600">
                Very helpful! I needed some changes made to my website, and they
                walked me through the process step by step. I look forward to
                buying more themes from this author!
              </p>
            </div>

            <div className="bg-white review_box p-6 rounded-lg shadow-lg">
              <div className="flex items-center mb-4">
                <div className="mr-4">
                  <img
                    src={"/assets/envato.png"}
                    alt="Envato"
                    className=" p-3 w-12 h-12 rounded-full bg-green-600"
                  />
                </div>
                <div>
                  <h5 className="font-semibold text-lg text-gray-800">
                    sorathiyameet777
                  </h5>
                  <span className="text-sm text-gray-500">India</span>
                </div>
              </div>
              <div className="flex mb-4">
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
              </div>
              <p className="text-gray-600">
                Great Code Quality and Customer support. I asked him for some
                extra files and he provided everything that I wanted plus one
                more file that he thought I may need. Great service and GREAT
                GREAT GREAT comments given very well commented code. The design
                aesthetics are great. No code replication, only when necessary.
                Overall, the product is value for money. I'd say value of money
                x10, he should increase the price.
              </p>
            </div>

            <div className="bg-white review_box p-6 rounded-lg shadow-lg">
              <div className="flex items-center mb-4">
                <div className="mr-4">
                  <img
                    src={"/assets/envato.png"}
                    alt="Envato"
                    className="p-3 w-12 h-12 rounded-full bg-green-600"
                  />
                </div>
                <div>
                  <h5 className="font-semibold text-lg text-gray-800">
                    freephpbr
                  </h5>
                  <span className="text-sm text-gray-500">Brazil</span>
                </div>
              </div>
              <div className="flex mb-4">
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
              </div>
              <p className="text-gray-600">
                I recommend buying this theme! This theme is professional, with
                beautiful design, and works great! The author offers one of the
                best customer supports, always ready to help, attentive, and
                very professional. Buy it, you’ll like it!
              </p>
            </div>

            <div className="bg-white review_box p-6 rounded-lg shadow-lg">
              <div className="flex items-center mb-4">
                <div className="mr-4">
                  <img
                    src={"/assets/envato.png"}
                    alt="Envato"
                    className="p-3 w-12 h-12 rounded-full bg-green-600"
                  />
                </div>
                <div>
                  <h5 className="font-semibold text-lg text-gray-800">
                    libertyzen
                  </h5>
                  <span className="text-sm text-gray-500">Spain</span>
                </div>
              </div>
              <div className="flex mb-4">
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
              </div>
              <p className="text-gray-600">
                Great customer support!! Fast, kind, and effective!! 100%
                recommended. Thanks for everything!
              </p>
            </div>

            <div className="bg-white review_box p-6 rounded-lg shadow-lg">
              <div className="flex items-center mb-4">
                <div className="mr-4">
                  <img
                    src={"/assets/envato.png"}
                    alt="Envato"
                    className="p-3 w-12 h-12 rounded-full bg-green-600"
                  />
                </div>
                <div>
                  <h5 className="font-semibold text-lg text-gray-800">fuhrj</h5>
                  <span className="text-sm text-gray-500">United States</span>
                </div>
              </div>
              <div className="flex mb-4">
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
                <i className="fas fa-star text-yellow-400"></i>
              </div>
              <p className="text-gray-600">
                Easy template to work with, with minimal components. The design
                quality is great. I had a few questions about the template, and
                support responded very quickly.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Review;
